/* BestAtTech theme — base JS. Prices are formatted in the shopper's active currency. */
(function(){
  'use strict';

  const $$ = (sel, root) => Array.from((root||document).querySelectorAll(sel));
  const $  = (sel, root) => (root||document).querySelector(sel);
  const CURRENCY = document.documentElement.dataset.currency || 'USD';
  const fmt = (n) => new Intl.NumberFormat('en-US').format(n);
  const cur = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: CURRENCY, maximumFractionDigits: 0 }).format(Math.round(n));

  $$('[data-countdown]').forEach(el => {
    const target = el.dataset.countdown;
    const h = el.querySelector('[data-h]');
    const m = el.querySelector('[data-m]');
    const s = el.querySelector('[data-s]');
    function endTime(){
      if (target === 'midnight') { const d = new Date(); d.setHours(23,59,59,0); return d.getTime(); }
      const t = Date.parse(target);
      return isNaN(t) ? Date.now() + 3600000 : t;
    }
    function tick(){
      const diff = Math.max(0, endTime() - Date.now());
      const H = Math.floor(diff/3.6e6), M = Math.floor(diff/6e4)%60, S = Math.floor(diff/1000)%60;
      const pad = n => String(n).padStart(2,'0');
      if (h) h.textContent = pad(H);
      if (m) m.textContent = pad(M);
      if (s) s.textContent = pad(S);
    }
    tick(); setInterval(tick, 1000);
  });

  $$('[data-deal]').forEach(deal => {
    const el = deal.querySelector('[data-watchers]');
    if (!el) return;
    let v = parseInt(el.textContent, 10) || 22;
    setInterval(() => { v = Math.max(10, Math.min(35, v + Math.round((Math.random()-.5)*4))); el.textContent = v; }, 2200);
  });

  const liveBar = $('[data-live-bar]');
  if (liveBar) {
    const vEl = $('[data-viewers]', liveBar);
    const oEl = $('[data-orders]', liveBar);
    const sEl = $('[data-saved]', liveBar);
    if (vEl) { let v = parseInt(vEl.textContent.replace(/\s/g, ''), 10) || 18; setInterval(() => { v = Math.max(8, Math.min(28, v + Math.round((Math.random()-.5)*3))); vEl.textContent = fmt(v); }, 1700); }
    if (oEl) { let v = parseInt(oEl.textContent.replace(/\s/g, ''), 10) || 4; setInterval(() => { if (Math.random() < 0.3) { v += 1; oEl.textContent = fmt(v); } }, 45000); }
    if (sEl) { let v = parseInt(sEl.textContent.replace(/[^0-9]/g, ''), 10) || 340; setInterval(() => { v += 3 + Math.floor(Math.random()*12); sEl.textContent = cur(v); }, 6000); }
  }

  $$('.ttw-sec').forEach(sec => {
    const rail = $('[data-rail]', sec);
    if (!rail) return;
    const prev = $('[data-rail-prev]', sec), next = $('[data-rail-next]', sec);

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const SPEED = 60; // px per sekund
    let paused = false, pauseTimer = null, lastTs = null;

    function pauseAuto(resumeAfterMs){
      paused = true;
      clearTimeout(pauseTimer);
      if (resumeAfterMs) pauseTimer = setTimeout(() => { paused = false; lastTs = null; }, resumeAfterMs);
    }
    function resumeAuto(){ clearTimeout(pauseTimer); paused = false; lastTs = null; }

    if (prev) prev.addEventListener('click', () => { rail.scrollBy({left: -380, behavior: 'smooth'}); pauseAuto(1800); });
    if (next) next.addEventListener('click', () => { rail.scrollBy({left:  380, behavior: 'smooth'}); pauseAuto(1800); });

    // Pause ved interaksjon, så man rekker å trykke "legg i kurv" eller bla manuelt
    rail.addEventListener('mouseenter', () => pauseAuto());
    rail.addEventListener('mouseleave', () => resumeAuto());
    rail.addEventListener('touchstart', () => pauseAuto(), { passive: true });
    rail.addEventListener('touchend', () => pauseAuto(2200), { passive: true });
    rail.addEventListener('wheel', () => pauseAuto(2200), { passive: true });

    function step(ts){
      requestAnimationFrame(step);
      if (reduceMotion || paused) { lastTs = ts; return; }
      if (lastTs == null) { lastTs = ts; return; }
      const dt = (ts - lastTs) / 1000;
      lastTs = ts;
      const maxScroll = rail.scrollWidth - rail.clientWidth;
      if (maxScroll <= 1) return;
      let newLeft = rail.scrollLeft + SPEED * dt;
      if (newLeft >= maxScroll - 1) newLeft = 0; // loop sømløst tilbake til start
      rail.scrollLeft = newLeft;
    }
    if (rail.scrollWidth > rail.clientWidth) requestAnimationFrame(step);
  });

  const FAVS_KEY = 'ywg.favs'; // key kept so saved favorites survive the theme switch
  const favs = new Set(JSON.parse(localStorage.getItem(FAVS_KEY) || '[]'));
  function paintFavs(){ $$('[data-fav]').forEach(btn => btn.classList.toggle('on', favs.has(btn.dataset.fav))); }
  paintFavs();
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-fav]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    const id = btn.dataset.fav;
    if (favs.has(id)) favs.delete(id); else favs.add(id);
    localStorage.setItem(FAVS_KEY, JSON.stringify([...favs]));
    paintFavs();
  });

  const drawer = $('[data-cart-drawer]');
  const scrim  = $('[data-cart-scrim]');
  function openDrawer(){ if (!drawer) return; drawer.classList.add('on'); scrim.classList.add('on'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ if (!drawer) return; drawer.classList.remove('on'); scrim.classList.remove('on'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-scrim]')) { e.preventDefault(); closeDrawer(); return; }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  async function refreshDrawer(){
    try {
      const body = $('[data-cart-drawer-body]');
      if (body) {
        const page = await fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } }).then(r => r.text());
        const doc = new DOMParser().parseFromString(page, 'text/html');
        const fresh = doc.querySelector('[data-cart-drawer-body]');
        if (fresh) body.innerHTML = fresh.innerHTML;
      }
    } catch(e) {}
  }
  async function refreshCartUI(){
    try {
      const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
      updateCartCount(cart.item_count);
      const ctLabel = $('[data-cart-count-label]');
      if (ctLabel) ctLabel.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
      await refreshDrawer();
    } catch(e) { console.error(e); }
  }

  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
      if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || 'Could not add to cart'); }
      await refreshCartUI(); openDrawer(); toast('Added to cart');
    } catch(err) { console.error(err); toast(err.message || 'Could not add to cart', true); }
    finally { if (btn) btn.disabled = false; }
  });

  function updateCartCount(n){
    let pill = $('[data-cart-count]');
    if (pill) { pill.textContent = n; pill.style.display = n > 0 ? '' : 'none'; }
    else if (n > 0) {
      const cart = $('[data-cart-toggle]');
      if (cart) { const span = document.createElement('span'); span.className='pill'; span.setAttribute('data-cart-count',''); span.textContent=n; cart.appendChild(span); }
    }
  }

  async function updateCartLine(key, qty){
    try {
      const res = await fetch('/cart/change.js', { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      if (!res.ok) throw new Error('Update failed');
      window.location.reload();
    } catch(e) { console.error(e); toast('Could not update the cart', true); }
  }
  document.addEventListener('click', e => {
    const minus = e.target.closest('[data-cart-qty="minus"]'), plus = e.target.closest('[data-cart-qty="plus"]'), rm = e.target.closest('[data-cart-remove]');
    if (minus || plus) {
      const btn = minus || plus, row = btn.closest('[data-cart-row]'), input = row.querySelector('[data-cart-qty-input]');
      let v = parseInt(input.value, 10); v = Math.max(0, v + (minus ? -1 : 1));
      updateCartLine(btn.dataset.key, v);
    } else if (rm) { updateCartLine(rm.dataset.cartRemove, 0); }
  });

  document.addEventListener('click', async e => {
    const minus = e.target.closest('[data-drawer-qty="minus"]'), plus = e.target.closest('[data-drawer-qty="plus"]'), rm = e.target.closest('[data-drawer-remove]');
    if (minus || plus) {
      const btn = minus || plus, item = btn.closest('.drawer-item'), disp = item.querySelector('[data-drawer-qty-display]');
      let v = parseInt(disp.textContent, 10) + (minus ? -1 : 1); v = Math.max(0, v);
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: btn.dataset.key, quantity: v }) });
      await refreshCartUI();
    } else if (rm) {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: rm.dataset.drawerRemove, quantity: 0 }) });
      await refreshCartUI();
    }
  });

  const pdp = $('.pdp-wrap');
  if (pdp) {
    let productJSON = null;
    const dataEl = $('[data-product-json]', pdp);
    if (dataEl) { try { productJSON = JSON.parse(dataEl.textContent); } catch(e) {} }

    const qDisp = $('[data-qty-display]', pdp), qInp = $('[data-qty-input]', pdp), qBuy = $('[data-pdp-total]', pdp);
    let qty = 1;
    function setQty(v){ qty = Math.max(1, v); if (qDisp) qDisp.textContent = qty; if (qInp) qInp.value = qty; updateBuyPrice(); }
    $('[data-qty-minus]', pdp)?.addEventListener('click', () => setQty(qty - 1));
    $('[data-qty-plus]', pdp)?.addEventListener('click', () => setQty(qty + 1));

    const variantInput = $('[data-variant-id]', pdp);
    const selectedOptions = productJSON ? [...(productJSON.options || [])].map((_, i) => {
      const sel = pdp.querySelector('[data-option-value="' + i + '"].on');
      return sel ? sel.dataset.value : (productJSON.variants[0]?.options?.[i] || '');
    }) : [];

    function findVariant(opts){ if (!productJSON) return null; return productJSON.variants.find(v => opts.every((o, i) => v.options[i] === o)); }
    function moneyFormat(cents){ return new Intl.NumberFormat('en-US', { style: 'currency', currency: CURRENCY, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents/100); }
    function updateBuyPrice(){ if (!productJSON || !qBuy) return; const variant = findVariant(selectedOptions); if (variant) qBuy.textContent = moneyFormat(variant.price * qty); }
    function selectOption(optIdx, value){
      selectedOptions[optIdx] = value;
      pdp.querySelectorAll('[data-option-value="' + optIdx + '"]').forEach(b => { b.classList.toggle('on', b.dataset.value === value); });
      const disp = pdp.querySelector('[data-option-display="' + optIdx + '"]');
      if (disp) disp.textContent = value;
      const variant = findVariant(selectedOptions);
      if (variant && variantInput) variantInput.value = variant.id;
      if (variant && variant.featured_image && variant.featured_image.src) {
        let main = $('#pdp-active-img', pdp) || $('[data-pdp-main-img] img', pdp);
        if (main) { main.removeAttribute('srcset'); main.src = variant.featured_image.src; }
      }
      updateBuyPrice();
    }
    $$('[data-option-value]', pdp).forEach(b => { b.addEventListener('click', () => selectOption(parseInt(b.dataset.optionValue, 10), b.dataset.value)); });

    const tabs = $('[data-pdp-tabs]', pdp);
    if (tabs) {
      $$('button[data-tab]', tabs).forEach(b => {
        b.addEventListener('click', () => {
          const id = b.dataset.tab;
          $$('button[data-tab]', tabs).forEach(x => x.classList.toggle('on', x === b));
          $$('[data-tab-panel]', tabs).forEach(p => { p.hidden = p.dataset.tabPanel !== id; });
        });
      });
    }

    $$('[data-pdp-thumb]', pdp).forEach(t => {
      t.addEventListener('click', () => {
        $$('[data-pdp-thumb]', pdp).forEach(x => x.classList.toggle('on', x === t));
        let main = $('#pdp-active-img', pdp) || $('[data-pdp-main-img] img', pdp);
        if (main && t.dataset.imgUrl) { main.removeAttribute('srcset'); main.src = t.dataset.imgUrl; }
      });
    });

    const viewers = $('[data-pdp-viewers]', pdp);
    if (viewers) { let v = parseInt(viewers.textContent, 10) || 12; setInterval(() => { v = Math.max(4, Math.min(24, v + Math.round((Math.random()-.5)*3))); viewers.textContent = v; }, 2300); }

    const SALES = [['Berlin','2 min'],['Stockholm','8 min'],['Copenhagen','14 min'],['Amsterdam','22 min'],['Vienna','34 min'],['Paris','47 min'],['Oslo','1 hr']];
    const cityEl = $('[data-pdp-last-sale]', pdp), agoEl = $('[data-pdp-last-ago]', pdp);
    if (cityEl && agoEl) { let i = 0; setInterval(() => { i = (i + 1) % SALES.length; cityEl.textContent = SALES[i][0]; agoEl.textContent = SALES[i][1]; }, 3500); }
  }

  $$('.coll-view').forEach(view => {
    const grid = view.parentElement.parentElement.querySelector('[data-coll-grid]');
    const list = view.parentElement.parentElement.querySelector('[data-coll-list]');
    $$('button[data-view]', view).forEach(b => {
      b.addEventListener('click', () => {
        $$('button[data-view]', view).forEach(x => x.classList.toggle('on', x === b));
        const mode = b.dataset.view;
        if (grid) grid.hidden = mode !== 'grid';
        if (list) list.hidden = mode !== 'list';
      });
    });
  });

  $$('[data-filter-form]').forEach(f => {
    f.addEventListener('change', () => { clearTimeout(window.__filterDebounce); window.__filterDebounce = setTimeout(() => f.submit(), 250); });
    f.querySelectorAll('.coll-sort-opt').forEach(opt => { opt.addEventListener('click', () => { const input = opt.querySelector('input'); if (input) { input.checked = true; f.submit(); } }); });
  });

  let toastTimer = null;
  function toast(msg, isError) {
    let t = $('.ywg-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'ywg-toast';
      t.style.cssText = ['position:fixed','bottom:24px','left:50%','transform:translateX(-50%)','background:var(--surface)','border:1px solid var(--line-strong)','border-radius:999px','padding:10px 18px','font-size:13px','color:var(--text)','z-index:200','box-shadow:0 12px 40px rgba(0,0,0,.45)','display:flex','gap:8px','align-items:center','transition:opacity .2s'].join(';');
      document.body.appendChild(t);
    }
    t.innerHTML = '<span style="color:' + (isError ? 'var(--hot)' : 'var(--accent)') + '">' + (isError ? '✕' : '✓') + '</span> ' + msg;
    t.style.opacity = '1';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { t.style.opacity = '0'; }, 2800);
  }
})();

/* Mobilmeny: aapne/lukke panelet fra menyknappen i toppen. */
(function(){
  'use strict';
  const panel = document.getElementById('MobileMenu');
  const scrim = document.querySelector('.mnav-scrim');
  const opener = document.querySelector('[data-mnav-open]');
  if (!panel || !scrim || !opener) return;
  let lastFocus = null;

  function open(){
    lastFocus = document.activeElement;
    panel.hidden = false; scrim.hidden = false;
    requestAnimationFrame(() => { panel.classList.add('on'); scrim.classList.add('on'); });
    opener.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const first = panel.querySelector('[data-mnav-close]');
    if (first) first.focus();
  }
  function close(){
    if (panel.hidden) return;
    panel.classList.remove('on'); scrim.classList.remove('on');
    opener.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(() => { panel.hidden = true; scrim.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  opener.addEventListener('click', open);
  document.addEventListener('click', e => { if (e.target.closest('[data-mnav-close]')) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  window.matchMedia('(min-width: 901px)').addEventListener('change', e => { if (e.matches) close(); });
})();
